import { useEffect, useRef } from 'react'
import { trackSectionView } from '../utils/mixpanel'

// Hook to track when sections come into view
export const useScrollTracking = (sectionName: string) => {
  const sectionRef = useRef<HTMLElement>(null)
  const hasTracked = useRef(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasTracked.current) {
            trackSectionView(sectionName)
            hasTracked.current = true
          }
        })
      },
      {
        threshold: 0.5, // Track when 50% of section is visible
      },
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current)
      }
    }
  }, [sectionName])

  return sectionRef
}
